interface BrandLookupButtonProps {
  onClick: () => void
  disabled?: boolean
  loading?: boolean
  title?: string
}

/**
 * Looks and reads like an actual button (not a bare text link) so the AI brand-color
 * lookup (plan §4.1) reads as an affordance, not a caption. Shared across Outside-In,
 * Inside-Out, and the Edit Dashboard modal so the three stay visually identical.
 */
export default function BrandLookupButton({ onClick, disabled, loading, title }: BrandLookupButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-semibold text-purple-700 bg-purple-50 border border-purple-200 rounded-md hover:bg-purple-100 hover:border-purple-300 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-purple-50 disabled:hover:border-purple-200"
    >
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className={`w-3.5 h-3.5 flex-shrink-0 ${loading ? 'animate-pulse' : ''}`}
        aria-hidden="true"
      >
        <path d="m12 3-1.9 5.8a2 2 0 0 1-1.287 1.288L3 12l5.8 1.9a2 2 0 0 1 1.288 1.287L12 21l1.9-5.8a2 2 0 0 1 1.287-1.288L21 12l-5.8-1.9a2 2 0 0 1-1.288-1.287Z" />
      </svg>
      {loading ? 'Checking…' : 'Detect brand color'}
    </button>
  )
}
